import { ChevronRight } from "lucide-react";
import { Card } from "../../components/ui/patrones";
import { Etiqueta } from "../../components/ui/primitivos";
import type { Cliente } from "../../lib/consola-api";

/**
 * Las otras dos vistas del listado de clientes.
 *
 * `ClientList.tsx` tiene tres —`table`, `cards` y `list`—, igual que
 * presupuestos. La tabla es `DataTable`; estas van acá.
 */

export function EtiquetaTipo({ cliente }: { cliente: Cliente }) {
  return (
    <>
      <Etiqueta tono={cliente.tipoCliente === "INTERNO" ? "neutral" : "ok"}>
        {cliente.tipoCliente}
      </Etiqueta>
      {cliente.esVip ? (
        <span className="ml-1.5">
          <Etiqueta tono="aviso">VIP</Etiqueta>
        </span>
      ) : null}
    </>
  );
}

export function VistaTarjetas({
  clientes,
  alAbrir,
}: {
  clientes: readonly Cliente[];
  alAbrir: (c: Cliente) => void;
}) {
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {clientes.map((c) => (
        <button
          key={c.id}
          type="button"
          onClick={() => alAbrir(c)}
          className="rounded-xl border border-neutral-200 bg-white p-4 text-left shadow-sm transition-colors hover:border-neutral-300 hover:bg-neutral-50"
        >
          <div className="flex items-start justify-between gap-2">
            <p className="truncate font-semibold text-neutral-900">{c.razonSocial}</p>
          </div>
          <p className="truncate text-neutral-500 text-sm">{c.nombreFantasia}</p>
          <p className="mt-2 font-mono text-neutral-500 text-xs">{c.cuit ?? "sin CUIT"}</p>
          <div className="mt-3">
            <EtiquetaTipo cliente={c} />
          </div>
        </button>
      ))}
    </div>
  );
}

export function VistaLista({
  clientes,
  alAbrir,
}: {
  clientes: readonly Cliente[];
  alAbrir: (c: Cliente) => void;
}) {
  return (
    <Card className="divide-y divide-neutral-200 overflow-hidden">
      {clientes.map((c) => (
        <button
          key={c.id}
          type="button"
          onClick={() => alAbrir(c)}
          className="flex w-full items-center gap-3 px-4 py-3 text-left transition-colors hover:bg-neutral-50"
        >
          <div className="min-w-0 flex-1">
            <p className="truncate font-medium text-neutral-900 text-sm">{c.razonSocial}</p>
            <p className="truncate text-neutral-500 text-sm">
              {c.nombreFantasia}
              {c.cuit ? ` · ${c.cuit}` : ""}
            </p>
          </div>
          <div className="shrink-0">
            <EtiquetaTipo cliente={c} />
          </div>
          <ChevronRight className="h-4 w-4 shrink-0 text-neutral-400" aria-hidden="true" />
        </button>
      ))}
    </Card>
  );
}

export function SinResultados({ mensaje }: { mensaje: string }) {
  return (
    <Card className="p-8 text-center text-neutral-500 text-sm">
      <p>{mensaje}</p>
    </Card>
  );
}
